import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [RouterModule, TranslatePipe],
  template: `
    <div class="flex items-center justify-center h-screen">
      <div class="text-center">
        <h1 class="typo-display1 text-neutral-300">404</h1>
        <p class="mb-1">
          {{ 'not-found.message' | translate }}
        </p>
      </div>
    </div>
  `,
  styles: [``],
})
export class NotFoundPage {}
